//import images from 'assets/images/images'
import { useRequest } from 'hooks/useRequest'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getAllBasketFunc, useEffectTrigger } from 'redux/features/general/generalSlice';
import auth from 'utils/Auth';
import {RiDeleteBin6Line} from 'react-icons/ri'
import ApprovalModal from 'components/approvalModal/ApprovalModal';
import {MdModeEditOutline} from 'react-icons/md';
import images from 'assets/images/images';
import useTranslate from 'hooks/useTranslate';
import { FormattedNumber, IntlProvider } from 'react-intl'
import {BiMinus, BiPlus} from 'react-icons/bi';
import { dataLayerPush } from 'utils/Datalayer';

const Order = ({order, setIsOpenDrawer, setProductStage, setSelectedProduct, setProductCount}) => {
  const [request]= useRequest();
  const dispatch = useDispatch();
  const [approvalModal, setApprovalModal] = useState(false);
  const [openEdit, setOpenEdit] = useState({open: false, id: null})
  const drRef = useRef(null)
  const {t} = useTranslate()
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (drRef.current && !drRef.current.contains(event.target)) {
        setOpenEdit({open: false, id: null})
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [drRef]);
  const updateItem = (product) => {
    setSelectedProduct({id: product?.productId, item: product})
    setProductCount(product?.quantity)
    setIsOpenDrawer(true)
    setProductStage(2)

 }
 const newProductCountFunc = (type, order) => {
    if (order?.quantity  > 1 || type != "decrement") {
    const newData = {
      "productId": order?.productId,
      "quantity": type == 'increment' ?  1 :  -1 ,
      "attributes": [
          ...order.attributes.map((ord) => (
              {             
                  //"productId": 8,
                  "productAttributeId": ord.productAttributeId,
                  "value": ord.value
              }
          ))
          ]  
       }
      request('/ShoppingCart/UpdateCart', { 
          method: 'POST',
          data: newData,
          headers: {
            restaurantId: auth.getUserChoises()?.restaurantId,
            deliveryType: auth.getUserChoises()?.deliveryType,
            neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
            regionId: auth.getUserChoises()?.regionId,
  
          }
        }).then((res) => {
            if(res.data){
              dataLayerPush({ ecommerce: null });
              dataLayerPush({
                event:"add_to_cart",
                ecommerce: {
                  item_list_name: "Listeleme Sayfası",
                  currency: "TRY",
                  items: [order]?.map((prev, i) => ({
                    item_id: prev.productId,
                    item_name: prev.productName,
                    affilication: "Tavuk Dünyası",
                    discount: prev.discountAmount,
                    index: i,
                    item_brand: "Tavuk Dünyası",
                    item_list_name: "Listeleme Sayfası",
                    price: prev.unitPrice,
                    quantity: newData.quantity
                  }))
                }
              })
              dispatch(getAllBasketFunc(res?.data?.result))
              toast.success(t('successfullToast',{type:t('update'),name:''}))
            }
        })
  }
}

  const deleteProduct = () => {
      request(`/ShoppingCart/RemoveItem?id=${order.id}`, {
        method: 'POST',
        //data: {id : id},
        headers: {
          restaurantId: auth.getUserChoises()?.restaurantId,
          deliveryType: auth.getUserChoises()?.deliveryType,
          neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
          regionId: auth.getUserChoises()?.regionId,
    
        }
      }).then((res) => {
        if(res.data){
          dataLayerPush({ ecommerce: null });
          dataLayerPush({
            event:"remove_from_cart",
            ecommerce: {
              item_list_name: "Listeleme Sayfası",
              currency: "TRY",
              items: [order]?.map((prev, i) => ({
                item_id: prev.productId,
                item_name: prev.productName,
                affilication: "Tavuk Dünyası",
                discount: prev.discountAmount,
                index: i,
                item_brand: "Tavuk Dünyası",
                item_list_name: "Listeleme Sayfası",
                price: prev.unitPrice
              }))
            }
          })
          toast.success(t('successfullToast',{type:t('delete'),name:''}))
          dispatch(useEffectTrigger(Math.floor(Math.random() * 1000)))
          setApprovalModal(false)
        }
    })
  }
  const openDropdownMenu = (id) => {
    setOpenEdit({open: !openEdit.open, id: id})
  }
  return (
    <div className='payment-left-order-container-card'>
        <div className='cardFlex'>
        <div className='payment-left-order-container-card-left'>
            <div className='incdecrement sm'>
              <BiMinus onClick={()=>newProductCountFunc('decrement',order)} size={16}/>  
              <div className='body-m'>{order?.quantity || 1}</div>
              <BiPlus onClick={()=>newProductCountFunc('increment',order)} size={16}/>
            </div>
            <div className='payment-left-order-container-card-left-text'>
               <div className='header-s text-primary'>{order?.productName}</div>
               <div className='header-m text-orange'>
               { <IntlProvider locale={'tr'} defaultLocale="en">
                  <FormattedNumber
                  maximumFractionDigits={0}
                  minimumFractionDigits={0}
                  value={order?.unitPrice}
                  style={'decimal'}
                  />
                </IntlProvider>} TL
               </div>
               {
                order?.warnings?.length > 0 && <div className='body-xs text-danger'>({order?.warnings?.join(', ')})</div>
               }
            </div>
        </div>
        <div className='payment-left-order-container-card-right'>
              <img src={order?.pictureUrl} alt="" />
              <div className='payment-left-order-container-card-right-menu'>
              <img onClick={() => openDropdownMenu(order?.id)} src={images.add2} alt="" />
                {(openEdit?.open && openEdit?.id == order?.id) &&
                  <div ref={drRef} className='payment-left-order-container-card-right-menu-item'>
                      <div onClick={() => updateItem(order)}><MdModeEditOutline size={30} color='#96004B'/> {t('updateBtn')}</div>
                      <div onClick={() => setApprovalModal(true)} ><RiDeleteBin6Line size={25}/> {t('removeBtn')}</div>
                  </div>
                  } 
              </div>
       </div>
        </div>
        <div className='addNote-container'>
        {
                    order?.attributes?.map((or,i) => (
                      <div className='addNote' key={i}>{or?.valueName}, </div>
                    ))
                    }
        </div>
                 
        {/* {order?.pictureUrl && <div className='addNote'>{images?.addNote}</div>} */}
			<ApprovalModal onClose={approvalModal} title={t('sureDeleteProductText')}  closeModal={() => setApprovalModal(false)} onApproval={deleteProduct} />
         
    </div>
  )
}

export default Order